// The public website, for "View on website" links
export const SITE_URL = (import.meta.env.VITE_SITE_URL as string | undefined)?.replace(/\/$/, '') || 'https://elimishacharity.org';

export const donationPageUrl = (slug: string) => `${SITE_URL}/donations/${slug}`;
